var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17344",
    d: "M17.133 32a1.413 1.413 0 01-.258-.023 1.5 1.5 0 01-1.237-1.345l-1.173-13.247-13.071-.934a1.5 1.5 0 01-.524-2.856L29.87.14a1.5 1.5 0 011.993 1.988l-13.368 29a1.5 1.5 0 01-1.361.872M7.398 13.87l8.556.611a1.5 1.5 0 011.387 1.365l.788 8.906 9.3-20.176z",
    fill: "currentColor"
  })));
}
export default SvgLocation;